module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("\n      Load Overview\n\n      "), (_vm.canEditLoadDetails) ? _c('a', {
    staticClass: "btn btn-info btn-circle pull-right",
    on: {
      "click": _vm.handleEditingOverview
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editingOverview),
      expression: "!editingOverview"
    }],
    staticClass: "job-overview-details job-overview-details-load"
  }, [_c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Load Reference")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.reference_number) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Commodity")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.commodity_name) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Load Size")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.size) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Rate")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.rate) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Loading Date")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.loading_date) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Loading Time")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.loading_time) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Delivery Date")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.delivery_date) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Delivery Time")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.delivery_time) + "\n              ")])]), _vm._v(" "), (_vm.loadDecorated.job) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Pickup Reference")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.job.pickup_reference) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.loadDecorated.job) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Delivery Reference")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.job.delivery_reference) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.loadDecorated.job) ? _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', [_c('strong', [_vm._v("Order")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.job.order_reference) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.loadDecorated.notes) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('strong', [_vm._v("Driver Notes")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.loadDecorated.notes) + "\n              ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editingOverview),
      expression: "editingOverview"
    }],
    staticClass: "job-overview-details job-overview-details-load"
  }, [_c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Load Size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadSize),
      expression: "loadSize"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "Load Size"
    },
    domProps: {
      "value": (_vm.loadSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loadSize = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Loading Time")]), _vm._v(" "), _c('flat-pickr', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "loading_time",
      "config": _vm.flatPickerConfig,
      "placeholder": "Loading Time"
    },
    model: {
      value: (_vm.loadingTime),
      callback: function($$v) {
        _vm.loadingTime = $$v
      },
      expression: "loadingTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Loading Date")]), _vm._v(" "), _c('date-range', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    attrs: {
      "name": "loading_date",
      "single-date-picker": true,
      "opens": "right"
    },
    model: {
      value: (_vm.loadingDate),
      callback: function($$v) {
        _vm.loadingDate = $$v
      },
      expression: "loadingDate"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Delivery Time")]), _vm._v(" "), _c('flat-pickr', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "delivery_time",
      "config": _vm.flatPickerConfig,
      "placeholder": "Delivery Time"
    },
    model: {
      value: (_vm.deliveryTime),
      callback: function($$v) {
        _vm.deliveryTime = $$v
      },
      expression: "deliveryTime"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Delivery Date")]), _vm._v(" "), _c('date-range', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    attrs: {
      "name": "delivery_date",
      "single-date-picker": true,
      "opens": "right"
    },
    model: {
      value: (_vm.deliveryDate),
      callback: function($$v) {
        _vm.deliveryDate = $$v
      },
      expression: "deliveryDate"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Driver Notes")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "2",
      "placeholder": "Driver Notes"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "truck-selection"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Carrier")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "carrier_id",
      "options": _vm.carrierOptions,
      "disabled": _vm.jobIsNotEditable,
      "fetch-results": _vm.fetchCarrierResults
    },
    model: {
      value: (_vm.carrier),
      callback: function($$v) {
        _vm.carrier = $$v
      },
      expression: "carrier"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Truck")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "truck_id",
      "options": _vm.truckOptions,
      "disabled": _vm.jobIsNotEditable,
      "fetch-results": _vm.fetchTruckResults
    },
    model: {
      value: (_vm.truck),
      callback: function($$v) {
        _vm.truck = $$v
      },
      expression: "truck"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Configuration")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "truck_configuration_id",
      "disabled": _vm.jobIsNotEditable,
      "options": _vm.configurationOptions
    },
    model: {
      value: (_vm.truckConfiguration),
      callback: function($$v) {
        _vm.truckConfiguration = $$v
      },
      expression: "truckConfiguration"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group-outer last-input"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Driver")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "driver_id",
      "options": _vm.driverOptions,
      "disabled": _vm.jobIsNotEditable,
      "fetch-results": _vm.fetchDriverResults
    },
    model: {
      value: (_vm.driver),
      callback: function($$v) {
        _vm.driver = $$v
      },
      expression: "driver"
    }
  })], 1)]), _vm._v(" "), (_vm.hasDevice) ? _c('p', {
    staticClass: "help-block device-help-block"
  }, [_vm._v("Driver will be notified")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [(_vm.showOverviewSaveButton) ? _c('ladda-button', {
    attrs: {
      "type": "success",
      "size": "small",
      "on-click": _vm.handleSaveOverview
    }
  }, [_vm._v("\n                Save\n              ")]) : _vm._e()], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-2d2fa643"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/LoadOverview.vue
// module id = 965
// module chunks = 0